import React from "react"
import { Link } from "gatsby"
import { Card} from "react-bootstrap"
import Img from "gatsby-image"
const Post = ({ title, slug, date, body, show, fluid }) => {
  return ( 
  <Link to={slug} className="cat-post-link">
    <Card className="cat-post">
      <div>
        <Img className="cat-post-image" fluid={fluid}/>
                <Card.Subtitle>
              <span className="post-subtitle">{date}</span>
            </Card.Subtitle>
      </div>
      
    
      <Card.Body>
      

            <Card.Title>
              <Link className="cat-post-title" to={slug}>
                {title}
              </Link>
            </Card.Title>


        <Card.Text className="cat-post-text">{body}</Card.Text>

      </Card.Body>
      <div className="post-onhover-action">
      </div>
    </Card> </Link>
  )
}
export default Post
